import React, { createContext, useContext, useEffect, useState } from "react";

const PageContext = createContext(null);
  
export const PageProvider = ({ index: _index, url: _url, title, children }) => {
  const [index, setIndex] = useState(_index + 1);
  const [url, setUrl] = useState(`${_url}${index !== 0 ? '/' : ''}${title}`);

  const context = {
    url,
    index,
    title
  }
  
  return (
    <PageContext.Provider value={context}>
      { children }
    </PageContext.Provider>
  );
};

export const usePageContext = () => useContext(PageContext);